import React, { useState, useEffect, useRef } from 'react';
import FadeIn from './FadeIn';
import { useImagePreloader } from '../hooks/useImagePreloader';

const galleryPhotos = [
  "https://ik.imagekit.io/aeu02xvjgn/Ad%20Images/220609_W_Newmann-0496.jpg",
  "https://ik.imagekit.io/aeu02xvjgn/Ad%20Images/01-details%20padua%20hills%20theatre-179.jpg",
  "https://ik.imagekit.io/aeu02xvjgn/Ad%20Images/_MG_7189%20E1.jpg",
];

const TransitionCarousel = () => {
  const [current, setCurrent] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setCurrent(c => (c + 1) % galleryPhotos.length);
    }, 5000);
    return () => clearInterval(timerRef.current);
  }, []);

  return (
    <div className="relative w-full overflow-hidden mt-32" style={{ height: '70vh' }}>
      {galleryPhotos.map((src, i) => (
        <div
          key={i}
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('${src}')`,
            opacity: i === current ? 1 : 0,
            transform: i === current ? 'scale(1.05)' : 'scale(1)',
            transition: 'opacity 1.5s ease-in-out, transform 8s ease-out',
            willChange: 'opacity, transform',
          }}
        />
      ))}
      <div className="absolute top-0 left-0 right-0 z-10 pointer-events-none" style={{ height: '200px', background: 'linear-gradient(to bottom, #FCFAF6 0%, transparent 100%)' }} />
      <div className="absolute bottom-0 left-0 right-0 z-10 pointer-events-none" style={{ height: '200px', background: 'linear-gradient(to top, rgba(245, 240, 230, 0.95) 0%, transparent 100%)' }} />
      
      <div className="absolute inset-0 z-20 flex flex-col items-center justify-center pointer-events-none">
        <div className="bg-brand-charcoal/40 backdrop-blur-md px-10 py-8 text-center border border-brand-vintage/10">
          <span className="text-brand-vintage/80 uppercase tracking-[0.4em] text-[9px] font-bold block mb-4">Real Celebrations</span>
          <p className="font-serif text-brand-vintage text-3xl md:text-4xl font-light italic">Every love story is unique</p>
        </div>
      </div>

      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 flex gap-3 z-20">
        {galleryPhotos.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            aria-label={`Slide ${i + 1}`}
            className={`h-1 rounded-full transition-all duration-700 ${i === current ? 'bg-brand-vintage w-10' : 'bg-brand-vintage/40 w-2 hover:bg-brand-vintage/80'}`}
          />
        ))}
      </div>
    </div>
  );
};

const Weddings = () => {
  useImagePreloader(galleryPhotos, true);

  return (
    <section id="weddings" className="bg-brand-vintage">
      <div className="max-w-7xl mx-auto px-6 pt-32 md:pt-40">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24 items-center mb-16">
          <FadeIn className="w-full lg:w-1/2">
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-brand-charcoal mb-6 leading-[1.1] font-light tracking-tight">
              The Experience
            </h2>
            <p className="font-serif text-2xl md:text-3xl text-brand-olive italic font-light mb-10">
              A private estate wedding that moves naturally from first look to final sendoff.
            </p>
            <div className="space-y-6">
              <p className="font-sans text-brand-charcoal/80 leading-relaxed font-light text-lg tracking-wide">
                Padua is designed for couples who want the exclusivity of a private villa and the flow of a masterfully executed event. Your day begins with calm preparation in the Bridal Suite, moves into cinematic portraits beneath the olive trees, continues with an outdoor ceremony framed by historic architecture, and transitions into a chef-driven dinner service inside the ballroom.
              </p>
              <p className="font-sans text-brand-charcoal/70 leading-relaxed font-light text-base tracking-wide">
                We believe a wedding venue should offer more than just a single room. The estate gives each part of your day its own distinct, cohesive setting while keeping the guest experience smooth, elegant, and deeply personal.
              </p>
            </div>
          </FadeIn>
          
          <FadeIn delay={0.2} className="w-full lg:w-1/2 relative">
            <div className="aspect-[4/5] overflow-hidden rounded-sm shadow-[30px_30px_0px_0px_rgba(217,204,186,0.2)] md:shadow-[50px_50px_0px_0px_rgba(217,204,186,0.2)] border border-brand-stone/20">
              <img 
                src="https://ik.imagekit.io/aeu02xvjgn/21-BBR63144.jpg?updatedAt=1776889999898" 
                alt="Indoor-outdoor wedding flow at Padua Hills Theatre" 
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-[1.5s]"
                loading="lazy"
              />
            </div>
          </FadeIn>
        </div>
      </div>
      <TransitionCarousel />
    </section>
  );
};

export default Weddings;